function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.4,
  d: "M2.21 10.64h59.57v42.72H2.21z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.21 10.64l26.51 25.53a4.45 4.45 0 006.15 0l26.92-25.53M2.21 53.36l22.98-20.58M61.79 53.36L38.81 32.78",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.4
});

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+bWFpbDwvdGl0bGU+PHJlY3QgeD0iMi4yMSIgeT0iMTAuNjQiIHdpZHRoPSI1OS41NyIgaGVpZ2h0PSI0Mi43MiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI0LjQiLz48cGF0aCBkPSJNMi4yMSwxMC42NCwyOC43MiwzNi4xN2E0LjQ1LDQuNDUsMCwwLDAsNi4xNSwwTDYxLjc5LDEwLjY0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQuNCIvPjxsaW5lIHgxPSIyLjIxIiB5MT0iNTMuMzYiIHgyPSIyNS4xOSIgeTI9IjMyLjc4IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQuNCIvPjxsaW5lIHgxPSI2MS43OSIgeTE9IjUzLjM2IiB4Mj0iMzguODEiIHkyPSIzMi43OCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI0LjQiLz48L3N2Zz4=";
export { SvgMail as ReactComponent };